import Vue from 'vue'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

import App from './App'
import Page from '@/components/Page'
import router from './router'
import store from './store'

Vue.config.productionTip = false

const config = {
  apiKey: 'AIzaSyDinf-toihTI-xWNFT4Z6J6nEalCg6t8yI',
  authDomain: 'bicg-semaforo.firebaseapp.com',
  databaseURL: 'https://bicg-semaforo.firebaseio.com',
  projectId: 'bicg-semaforo',
  storageBucket: 'bicg-semaforo.appspot.com',
  messagingSenderId: '673014752157'
}
firebase.initializeApp(config)

const settings = {timestampsInSnapshots: true}
const db = firebase.firestore()
db.settings(settings)

// This makes the Page component available in all other components
Vue.component(Page.name, Page)

let app
function initApp () {
  // We now initialize the app only when we are sure Firebase Auth object is ready to use
  // Because in the lifecycle of our app, the execution of our navigation guard beforeEach
  // take place before Firebase initialization end
  if (!app) {
    console.log('@main.js/init app')
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  }
}

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    // User is signed in.
    console.log('@main.js/signed in user: ', user)
    store.dispatch('getUserData', {id: user.uid})
      .then(() => {
        initApp()
      })
  } else {
    // User is signed out.
    console.log('@main.js/no user signed in')
    initApp()
  }
})



// WEBPACK FOOTER //
// ./src/main.js